import { CriteriaSchema as Schema } from './CriteriaSchema'
import { encode } from './encode'
import { toSellerListBuilderPreviewInput } from './toSellerListBuilderPreviewInput'
import { toDomain } from './toDomain'
export {
  ConditionTypeSchema, DateRangeFilterSchema, EquityInfoSchema, FiltersSchema,
  LocationSchema, MlsDiscountSchema, MlsFiltersSchema, MlsPriceReductionSchema, MlsStatusSchema, OwnerTypeSchema, PreforeclosureSchema,
  PropertyDetailsSchema, RangeFilterSchema,
} from './CriteriaSchema'

type CriteriaSchema = Schema

const CriteriaSchema = {
  toDomain,
  encode,
  toSellerListBuilderPreviewInput,
  schema: Schema,
}

export default CriteriaSchema
